import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import Button from "../components/Button";
import ComboboxInput from "../components/ComboboxInput";
import APIS from "../constant/Endpoint";
import useGetHook from "../customHooks/useGetHook";
import usePostHook from "../customHooks/usePostHook";
import { queryClient } from "../DashboardLayout";
import { setupBranchValidationForm } from "../utils/validationSchema";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

const SetupBranch = (props: any) => {
  const { profile } = props;
  const { refetch: refetchDefaultBranch } = useGetHook({
    queryKey: [`default-branch`],
    url: `${APIS.USER}me/`,
    params: {},
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(setupBranchValidationForm),
    defaultValues: async () => {
      let { data }: any = await refetchDefaultBranch();
      return {
        branch: {
          ...data?.default_branch,
        },
      };
    },
  });

  const { mutateAsync } = usePostHook({
    queryKey: ["ddfault-branch"],
  });

  const handleUpdate = async (values: any) => {
    const url = `${APIS.USER}update-default-branch/`;
    let formData = {
      branch: values?.branch,
      user: profile?.id,
    };
    try {
      //@ts-nocheck
      await mutateAsync({ url, formData, setError });
      queryClient.refetchQueries();
      props?.setOpenModal(false);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div>
      <ComboboxInput
        label={""}
        placeholder={"Select Branch"}
        url={APIS.BRANCH}
        queryKey={"branch"}
        register={register("branch")}
        errors={errors?.branch}
        name={"branch"}
        getValues={getValues}
        setValue={setValue}
        clearErrors={clearErrors}
      />
      <div className={tw`flex justify-end w-full`}>
        <div className={tw`w-[100px] mr-4`}>
          <Button
            label={"Submit"}
            onClick={handleSubmit((data: any) => handleUpdate(data))}
          />
        </div>
      </div>
    </div>
  );
};

export default SetupBranch;
